export class DashboardPendingOrderModel {
    start:number = 0
    end:number = 0
    description:string = ''
    total:number = 0

    constructor(d?:Partial<DashboardPendingOrderModel>) {
        Object.assign(this, d)
    }
}
